export default "__VITE_ASSET__BhmmU3C0__"